/**
 * Client-side sub-discipline filter (same table, filter rows).
 * Used for Piping (Piping / Tubing / Supports) and Electrical (Power / I&C / …)
 * when a full mechanical-style table switch is not warranted.
 */
import React, { useEffect, useRef, useState } from 'react';

const SubDisciplineFilter = ({
  label = 'Sub-discipline',
  options = [],
  value = 'all',
  onChange,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const current = value === 'all'
    ? { value: 'all', label: `All ${label}s` }
    : options.find((o) => o.value === value) || { value, label: value };

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setIsOpen((v) => !v)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 12px',
          borderRadius: 6,
          border: '1px solid #cbd5e1',
          background: '#fff',
          color: '#0f172a',
          fontSize: 13,
          fontWeight: 600,
          cursor: disabled ? 'not-allowed' : 'pointer',
          minWidth: 180,
          justifyContent: 'space-between',
        }}
        title={`Filter by ${label}`}
      >
        <span style={{ color: '#64748b', fontWeight: 500, marginRight: 4 }}>{label}:</span>
        <span>{current.label}</span>
        <span style={{ color: '#94a3b8', fontSize: 10 }}>{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && !disabled && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            zIndex: 50,
            minWidth: '100%',
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            boxShadow: '0 8px 24px rgba(15,23,42,0.12)',
            overflow: 'hidden',
          }}
        >
          <button
            type="button"
            onClick={() => { onChange('all'); setIsOpen(false); }}
            style={itemStyle(value === 'all')}
          >
            All {label}s
          </button>
          {options.map((o) => (
            <button
              key={o.value}
              type="button"
              onClick={() => { onChange(o.value); setIsOpen(false); }}
              style={itemStyle(value === o.value)}
            >
              {o.label}
              {o.count != null ? ` (${o.count})` : ''}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

function itemStyle(active) {
  return {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: '8px 12px',
    border: 'none',
    background: active ? '#e0f2fe' : '#fff',
    color: '#0f172a',
    fontSize: 13,
    fontWeight: active ? 700 : 500,
    cursor: 'pointer',
  };
}

export default SubDisciplineFilter;
